import {
  regex
} from 'vuelidate/lib/validators/common';
import { credentialsRegex } from '@/constants';

const validChars = regex('validChars', credentialsRegex);

export {
  validChars
};